import Navbar from "../componenets/Navbar";
import Sidebar from "../componenets/Sidebar";
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert"; 

// MUI Imports
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#596CFF",
        fontWeight: "bold",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover },
    '&:last-child td, &:last-child th': { border: 0 },
}));

function Messages() {
    const [messages, setMessages] = useState([]); 
    const [page, setPage] = useState(0); 
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const navigate = useNavigate();

    // 1. FETCH MESSAGES
    const fetchMessages = async () => {
        try {
            const apiPage = page + 1;
            const response = await axios.post(
                `https://globizsystems.com/messages/allrecived_messages?page=${apiPage}&size=${rowsPerPage}`
            );
            if (response.data) {
                setMessages(response.data.data || []); 
                setTotalCount(response.data.totalItems || 0);
            }
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    // 2. HELPER: EXTRACT MESSAGE CONTENT
    const getMessageContent = (item) => {
        if (item.type === 'text') {
            return item.text_body || "No text";
        } 
        if (item.type === 'image') {
            // Check nested caption in raw_json
            return item.raw_json?.image?.caption || "Photo Attachment";
        }
        if (item.type === 'document' || item.type === 'pdf') {
            return item.raw_json?.document?.caption || item.raw_json?.document?.filename || "Document Attachment";
        }
        return "Unknown Type";
    };

    // 3. HELPER: EXTRACT MEDIA URL
    const getMediaUrl = (item) => {
        if (item.type === 'image') return item.raw_json?.image?.url;
        if (item.type === 'document' || item.type === 'pdf') return item.raw_json?.document?.url;
        return null;
    };

    // 4. HANDLE DOWNLOAD / VIEW
    const handleMediaRequest = async (item, fileType) => {
        const mediaUrl = getMediaUrl(item);

        if (!mediaUrl) {
            swal("Error", "Media URL not found in message data", "error");
            return;
        }

        try {
            swal({
                title: "Downloading...",
                text: "Fetching from WhatsApp Servers",
                buttons: false,
                timer: 2000,
            });

            // Send URL to backend to proxy the download (Avoids CORS issues with WhatsApp/FB servers)
            const response = await axios.post('https://globizsystems.com/messages/download_media', 
                { url: mediaUrl }, 
                { responseType: 'blob' } 
            );

            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = fileURL;

            if (fileType === 'image') {
                window.open(fileURL, '_blank');
            } else {
                link.setAttribute('download', `file_${item.id}.${fileType === 'pdf' ? 'pdf' : 'doc'}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

        } catch (error) {
            console.error(error);
            swal("Error", "Failed to download. The WhatsApp link might have expired.", "error");
        }
    };

    // 5. MARK AS DONE
    const markAsDone = async (id) => {
        swal({
            title: "Are you sure?",
            text: "Mark this conversation as done?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                try {
                    const response = await axios.post('https://globizsystems.com/messages/mark_conversation_done', { id });
                    if(response.data.success) {
                        swal("Success", "Conversation closed.", "success");
                        fetchMessages(); 
                    }
                } catch (error) {
                    swal("Error", "Server error.", "error");
                }
            }
        });
    }

    useEffect(() => {
        fetchMessages();
    }, [page, rowsPerPage]);

    return (
        <>
            <Navbar />
            <div className="row"><Sidebar /></div>
            <main className="main-content position-relative h-100 border-radius-md contained ">
                <div className="container-fluid g-3 ">
                    <div className="card px-2 pt-3 pb-3 mb-4 cardbg">
                        <div className="container-fluid" style={{ backgroundColor: "white" }}>
                            <div className="col-12">
                                <div className="container-fluid pb-4 pt-3 g-3">
                                    <legend><b>Received Messages</b></legend>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 700 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>ID</StyledTableCell>
                                                    <StyledTableCell>Sender</StyledTableCell>
                                                    <StyledTableCell>Type</StyledTableCell>
                                                    <StyledTableCell>Content / Caption</StyledTableCell>
                                                    <StyledTableCell>Date</StyledTableCell>
                                                    <StyledTableCell align="center">Actions</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {messages.map((item) => (
                                                    <StyledTableRow key={item.id}>
                                                        {/* ID */}
                                                        <StyledTableCell>{item.id}</StyledTableCell>
                                                        
                                                        {/* Sender Name/Phone */}
                                                        <StyledTableCell>
                                                            <div style={{fontWeight:'bold'}}>{item.from_name}</div>
                                                            <div style={{fontSize:'0.8em', color:'#666'}}>{item.from_wa}</div>
                                                        </StyledTableCell>

                                                        {/* Type */}
                                                        <StyledTableCell style={{textTransform: 'capitalize'}}>
                                                            {item.type || 'text'}
                                                        </StyledTableCell>

                                                        {/* Content / Caption */}
                                                        <StyledTableCell>
                                                            {getMessageContent(item)}
                                                        </StyledTableCell>

                                                        {/* Date */}
                                                        <StyledTableCell>{new Date(item.createdAt).toLocaleString()}</StyledTableCell>

                                                        {/* Actions */}
                                                        <StyledTableCell align="center">
                                                            <div style={{display:'flex', gap:'8px', justifyContent:'center'}}>
                                                                
                                                                {/* VIEW (Image) */}
                                                                {item.type === 'image' && (
                                                                    <button 
                                                                        className="btn btn-info btn-sm"
                                                                        onClick={() => handleMediaRequest(item, 'image')}
                                                                    >
                                                                        View
                                                                    </button>
                                                                )}

                                                                {/* DOWNLOAD (PDF/Doc) */}
                                                                {(item.type === 'pdf' || item.type === 'document') && (
                                                                    <button 
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() => handleMediaRequest(item, 'pdf')}
                                                                    >
                                                                        Download
                                                                    </button>
                                                                )}

                                                                {/* DONE */}
                                                                <button 
                                                                    className="btn btn-primary btn-sm" 
                                                                    onClick={() => markAsDone(item.id)}
                                                                >
                                                                    Done
                                                                </button>
                                                            </div>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={totalCount}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={(e, newPage) => setPage(newPage)}
                                        onRowsPerPageChange={(e) => {
                                            setRowsPerPage(parseInt(e.target.value, 10));
                                            setPage(0);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
export default Messages;